import { unref as _unref, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = ["value", "cols", "rows", "maxlength"];
import AppgInput from '@/components/custom/AppgInput.vue';
import { toRefs } from 'vue';
export default {
  __name: 'AppgTextArea',
  props: {
    valid: {
      type: Boolean,
      default: true
    },
    invalidMessage: {
      type: String,
      default: ''
    },
    _class: {
      type: String,
      default: 'col-md-12'
    },
    label: {
      type: String,
      default: ''
    },
    required: {
      type: Boolean,
      default: false
    },
    modelValue: {
      type: [Object, String, Boolean, Number],
      default: null
    },
    cols: {
      type: Number,
      default: 5
    },
    rows: {
      type: Number,
      default: 2
    },
    maxLength: {
      type: [Number, String],
      default: ''
    }
  },
  emits: ['update:modelValue'],
  setup(__props, {
    emit: __emit
  }) {
    const emits = __emit;
    const props = __props;
    const {
      _class,
      label,
      required,
      modelValue,
      cols,
      rows,
      valid,
      invalidMessage
    } = toRefs(props);
    const input = ({
      target
    }) => {
      // modelValue.value = target.value;
      emits('update:modelValue', target.value);
    };
    return (_ctx, _cache) => {
      return _openBlock(), _createBlock(AppgInput, {
        _class: _unref(_class),
        label: _unref(label),
        required: _unref(required),
        "in-valid-message": _unref(invalidMessage),
        valid: _unref(valid)
      }, {
        default: _withCtx(() => [_createElementVNode("textarea", {
          class: "form-control text-area-scrollable",
          style: {
            "resize": "none"
          },
          value: _unref(modelValue),
          onInput: input,
          cols: _unref(cols),
          rows: _unref(rows),
          maxlength: __props.maxLength
        }, null, 40, _hoisted_1)]),
        _: 1
      }, 8, ["_class", "label", "required", "in-valid-message", "valid"]);
    };
  }
};